import { styled } from "@mui/material/styles";
import Modal from "@mui/material/Modal";

export default styled(Modal)(({ theme, ownerState }) => {
  const { darkMode } = ownerState;

  return {
    "& .MuiModal-root": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "& .MuiBox-root": {
      backgroundColor: darkMode ? theme.palette.background.dark : theme.palette.white.main,
      color: darkMode ? theme.palette.text.secondary : theme.palette.text.primary,
      borderRadius: "8px",
      padding: theme.spacing(3),
      boxShadow: theme.shadows[5],
    },
    h2: {
      color: darkMode ? theme.palette.text.secondary : theme.palette.text.primary,
    },
  };
});
